module.exports = __webpack_public_path__ + "static/media/Декларация_ОК_Р. Кузманова.bb18b037.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2020/Декларация_ОК_Р. Кузманова.pdf
// module id = 123
// module chunks = 0